package com.fireavert.user.data_models.requests

import kotlinx.serialization.Serializable

@Serializable
data class UserAuthByRefreshRequest(
    val refresh: String? = null,
    val id: Int? = null
)